import PropTypes from "prop-types";

import { onlyNumber } from "helpers/only-number";

import { checkOnlyLetters } from "helpers/only-text";

import Input from "components/common/input";

import styles from "./styles.module.css";

const FirstForm = ({ errors, form, setForm, handleInputFocus }) => {
  const handleInputOnChange = (type) => (event) => {
    const {
      target: { value },
    } = event;

    setForm({
      ...form,
      [type]: value,
    });
  };

  const handlePhoneInputChange = (event) => {
    // If the user entered a number and then gave up and deleted all numbers, it should be assigned null.
    // Because BE only accepts null values.
    const {
      target: { value },
    } = event;

    if (value.length === 0) {
      setForm({
        ...form,
        mobilePhone: null,
      });
      return;
    }

    const isValidPhoneNumber = onlyNumber(value) || value === "" || value.length < 11;
    const isPhoneNumberStartWithTheNumberIWant = value.charAt(0) !== "5";
    if (isValidPhoneNumber) {
      // Mobile phones should start with 5
      if (isPhoneNumberStartWithTheNumberIWant) {
        setTimeout(() => {
          setForm({
            ...form,
            mobilePhone: "",
          });
        }, 100);
        return;
      }
      setForm({
        ...form,
        mobilePhone: value,
      });
    }
  };

  const handleNameInputChange = (type) => (event) => {
    const {
      target: { value },
    } = event;
    if (checkOnlyLetters(value)) {
      setForm({
        ...form,
        [type]: value,
      });
    }
  };

  return (
    <div>
      <div>
        <label className={styles.inputTitle}>Ad - Soyad</label>
        <div className={styles.mailInput}>
          <Input
            errorMessage={errors?.memberFullName?.message}
            inputClass={styles.loginInput}
            type="text"
            placeholder="Ad - Soyad Giriniz"
            onChange={handleNameInputChange("memberFullName")}
            onFocus={() => handleInputFocus("memberFullName")}
            value={form.memberFullName || ""}
          />
        </div>
      </div>
      <div className={styles.fieldMargin}>
        <label className={styles.inputTitle}>Cep Telefonu</label>
        <div className={styles.mailInput}>
          <Input
            errorMessage={errors?.mobilePhone?.message}
            inputClass={styles.loginInput}
            type="text"
            placeholder="(5XX) XXX XX XX"
            onChange={handlePhoneInputChange}
            onFocus={() => handleInputFocus("mobilePhone")}
            value={form.mobilePhone || ""}
            phone
          />
        </div>
      </div>
      <div className={styles.fieldMargin}>
        <label className={styles.inputTitle}>E-posta Adresi</label>
        <div className={styles.mailInput}>
          <Input
            errorMessage={errors?.emailAddress?.message}
            inputClass={styles.loginInput}
            type="text"
            placeholder="E-posta Adresinizi Giriniz"
            onChange={handleInputOnChange("emailAddress")}
            onFocus={() => handleInputFocus("emailAddress")}
            value={form.emailAddress || ""}
          />
        </div>
      </div>
    </div>
  );
};

FirstForm.propTypes = {
  errors: PropTypes.object,
  form: PropTypes.object,
  setForm: PropTypes.func,
  handleInputFocus: PropTypes.func,
};

export default FirstForm;
